<template>
  <div
    v-for="(day, index) in openingHours"
    :key="index"
    :class="{ 'text-green font-weight-bold': isItToday(index) }"
  >{{ days[index] }}:
    <span>
      <span
        v-if="day.open"
        v-for="hour in day.hours"
      >{{ hour.open }} - {{ hour.close }}</span>
      <span v-else>geschlossen</span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import type { OpeningHoursWeek } from "@/types";

defineProps({
  openingHours: {
    type: Object as () => OpeningHoursWeek,
  }
})

const isItToday = (index: string) => {
  return index === new Date().toLocaleDateString('en-EN', { weekday: 'long' }).toLowerCase();
}

const days = ref({
  'monday': "Mo",
  'tuesday': "Di",
  'wednesday': "Mi",
  'thursday': "Do",
  'friday': "Fr",
  'saturday': "Sa",
  'sunday': "So"
});
</script>